import styled from 'styled-components';

export const BorderedDiv = styled.div`
  border: 1px solid #062173;
  margin-bottom: 24px;
  padding: 1em;
`;

export const SignContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;

  img,
  div.ui.error.message {
    margin: 0 auto;
  }

  img {
    height: 40px;
  }
`;
